import CpuIcon from "../../assets/icons/cpu.svg";
import DirectionsIcon from "../../assets/icons/directions.svg";
import ClustersIcon from "../../assets/icons/clusters.svg";
import TagsIcon from "../../assets/icons/tag.svg";
import NavigationIcon from "../../assets/icons/navigation.svg";
import InfoIcon from "../../assets/icons/info.svg";
import FlagRus from "../../assets/icons/flag-ru-active.svg";
import IconManyOperators from "../../assets/icons/icon-many-operators.svg";
import FintechLightning from "../../assets/icons/fintech_lightning.svg";
import IconWeakSignals from "../../assets/icons/weak_signal_active.svg";
import StackholdersGray from "../../assets/icons/stackholders-gray.svg";

interface IMenuItem {
  icon: string;
  label: string;
  tooltip: string;
  title?: string;
  width?: number;
  height?: number;
}
export const MENU_ITEMS: Map<string, IMenuItem[]> = new Map([
  [
    "map",
    [
      {
        icon: DirectionsIcon,
        label: "Directions",
        tooltip: "ТЕХНОЛОГИЧЕСКИЕ НАПРАВЛЕНИЯ",
        title: "Направления",
        width: 28,
        height: 28,
      },
      {
        icon: ClustersIcon,
        label: "Clusters",
        tooltip: "ТЕХНОЛОГИЧЕСКИЕ КЛАСТЕРЫ",
        title: "Кластеры",
        width: 28,
        height: 28,
      },
      {
        icon: CpuIcon,
        label: "CPU",
        tooltip: "ТЕХНОЛОГИИ",
        title: "Технологии",
        width: 28,
        height: 28,
      },
      // {icon: TagsIcon, label: "Tags", tooltip: "ТЕГИ", title: "Тэги"},
      // {
      //   icon: NavigationIcon,
      //   label: "Navigation",
      //   tooltip: "ОБУЧЕНИЕ НАВИГАЦИИ ПО РАДАРУ",
      //   title: "Навигация",
      //   width: 28,
      //   height: 28,
      // },
      // {
      //   icon: InfoIcon,
      //   label: "Info",
      //   tooltip: "ИНФОРМАЦИЯ О РАДАРЕ",
      //   title: "О радаре",
      //   width: 23,
      //   height: 23,
      // },
    ],
  ],
  [
    "molecula",
    [
      {
        icon: DirectionsIcon,
        label: "Directions",
        tooltip: "ТЕХНОЛОГИЧЕСКИЕ НАПРАВЛЕНИЯ",
      },
      {
        icon: ClustersIcon,
        label: "Clusters",
        tooltip: "ТЕХНОЛОГИЧЕСКИЕ КЛАСТЕРЫ",
      },
      {icon: CpuIcon, label: "CPU", tooltip: "ТЕХНОЛОГИИ"},
      {icon: TagsIcon, label: "Tags", tooltip: "ТЕГИ"},
      {
        icon: NavigationIcon,
        label: "Navigation",
        tooltip: "ОБУЧЕНИЕ НАВИГАЦИИ ПО РАДАРУ",
      },
      // {icon: InfoIcon, label: "Info", tooltip: "ИНФОРМАЦИЯ О РАДАРЕ"},
    ],
  ],
  [
    "esg",
    [
      {
        icon: ClustersIcon,
        label: "Directions",
        tooltip: "ПРОЕКТЫ",
        title: "Проекты",
      },
      // {
      //   icon: CpuIcon,
      //   label: "CPU",
      //   tooltip: "ПРОЕКТЫ",
      //   title: "Проекты",
      // },
      // {
      //   icon: NavigationIcon,
      //   label: "Navigation",
      //   tooltip: "ОБУЧЕНИЕ НАВИГАЦИИ ПО РАДАРУ",
      //   title: "Обучение навигации по радару",
      // },
      // {icon: InfoIcon, label: "Info", tooltip: "ИНФОРМАЦИЯ О РАДАРЕ"},
    ],
  ],
  [
    "fintech",
    [
      {
        icon: FintechLightning,
        label: "Trends",
        tooltip: "ТРЕНДЫ",
        title: "Тренды",
      },
      // {
      //   icon: InfoIcon,
      //   label: "Info",
      //   tooltip: "ИНФОРМАЦИЯ О РАДАРЕ",
      //   title: "Информация о радаре",
      // },
    ],
  ],
  [
    "weak_signals",
    [
      {
        icon: IconWeakSignals,
        label: "Trends",
        tooltip: "СЛАБЫЕ СИГНАЛЫ",
        title: "Слабые сигналы",
      },
      // {
      //   icon: InfoIcon,
      //   label: "Info",
      //   tooltip: "ИНФОРМАЦИЯ О РАДАРЕ",
      //   title: "Информация о радаре",
      // },
    ],
  ],
  [
    "stateInitiative",
    [
      {
        icon: FlagRus,
        label: "stateInitiative",
        tooltip: "ГОСУДАРСТВЕННЫЕ ИНИЦИАТИВЫ",
        title: "Государственные инициативы",
      },
      // {
      //   icon: IconManyOperators,
      //   label: "stackHolders",
      //   tooltip: "СТЕЙКХОЛДЕРЫ",
      //   title: "Стейкхолдеры",
      // },
      // {
      //   icon: NavigationIcon,
      //   label: "Navigation",
      //   tooltip: "ОБУЧЕНИЕ НАВИГАЦИИ ПО РАДАРУ",
      //   title: "Обучение навигации по радару",
      // },
      // {
      //   icon: InfoIcon,
      //   label: "Info",
      //   tooltip: "ИНФОРМАЦИЯ О РАДАРЕ",
      //   title: "Информация о радаре",
      // },
    ],
  ],
]);
